import { useMediaQuery, useTheme } from '@mui/material';
export const useResponsive = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.only('xs'));
  const isTablet = useMediaQuery(theme.breakpoints.only('sm'));
  const isBigTablet = useMediaQuery(theme.breakpoints.down('tablet'));
  const isDesktop = useMediaQuery(theme.breakpoints.up('xl'));

  const isMobileOrTablet = isMobile || isTablet;
  const isTablets = isTablet || isBigTablet;

  return { isMobile, isTablet, isBigTablet, isTablets, isDesktop, isMobileOrTablet };
};
